const faqInit = (block) => {
    // const faqs = block ? block[0].querySelectorAll(".bn-faq:not(.is-style-scroll-animated)") : document.querySelectorAll(".bn-faq:not(.is-style-scroll-animated)");
    const faqs = block ? block[0].querySelectorAll(".bn-faq") : document.querySelectorAll(".bn-faq");

    if (faqs && faqs.length) {
        faqs.forEach((faq) => {
            [...faq.querySelectorAll(".bn-faq__tab")].forEach((el) => {
                const answer = el.querySelector(".bn-faq__tab--answer");
                const content = answer.querySelector(".bn-faq__tab--text");

                el.addEventListener("click", () => {
                    const isOpen = el.classList.contains("--open");

                    if (!isOpen) {
                        el.classList.add("--open");
                        answer.style.height = answer.scrollHeight + "px";
                    } else {
                        el.classList.remove("--open");
                        answer.style.height = "0px";
                    }
                });
            });
        });
    }
}

// https://gsap.com/docs/v3/Plugins/ScrollTrigger/
// const faqAnimationInit = (block) => {
//     const faqs = block ? block[0].querySelectorAll(".bn-faq.is-style-scroll-animated") : document.querySelectorAll(".bn-faq.is-style-scroll-animated");

//     if (faqs && faqs.length) {
//         faqs.forEach((faq) => {
//             const answers = faq.querySelectorAll(".bn-faq__tab--answer")

//             if (answers && answers.length) {
//                 let answersScrolls = [];

//                 answers.forEach((answer, i) => {
//                     answersScrolls[i] = gsap.timeline({
//                         scrollTrigger: {
//                             id: `answer-${i}`,
//                             trigger: answer,
//                             start: "top +=55%",
//                             end: 'bottom 40%',
//                             scrub: true, // true value links the animation's progress directly to the ScrollTrigger's progress.
//                             ease: 'linear',
//                             onEnter: function () {
//                                 tabAnimation(answersScrolls[i], faq, answer);
//                                 answer.previousElementSibling.classList.toggle("active");
//                             },
//                             onLeaveBack: function () {
//                                 answer.previousElementSibling.classList.toggle("active");
//                             }
//                         }
//                     });
//                 })
//             }

//             function tabAnimation(timeline, faq, answer) {
//                 let faqHeight = faq.offsetHeight;
//                 let answerHeight = answer.offsetHeight;
//                 let newHeight = faqHeight - answerHeight;
//                 timeline.to(faq, {
//                     height: newHeight,
//                     duration: 0.3,
//                     onComplete: () => {
//                         ScrollTrigger.refresh();
//                     }
//                 }, "<").to(answer, {
//                     height: 0,
//                     paddingBottom: 0
//                 }, "<")
//             }
//         });
//     }
// }

document.addEventListener("DOMContentLoaded", function () {
    if (!document.body.classList.contains('block-editor-page') && !document.body.classList.contains('block-editor-iframe__body')) {
        faqInit();
        //faqAnimationInit();
    } else if (window.acf) {
        window.acf.addAction('render_block_preview/type=bn/faq', faqInit);
    }
});